import React, { FC, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { debounce } from 'lodash';
import { useConnection } from '../../connection/Application';
import { SelectProps } from 'antd/lib/select';
import Utils from '../../utils/Utils';
import './AdapterStyle.less';

type Props<VT> = {
  enum?: string;
  values?: any[];
  itemView?: (value: any) => React.ReactNode;
} & SelectProps<VT>;

export const AutoCompleteInput: FC<Props<any>> = (props) => {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState<any[]>([]);
  const fetchRef = React.useRef(0);
  const connection = useConnection();

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value?: string, initial?: any[]) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      if (!props.values) {
        setFetching(true);
        connection
          .get(`select-values/${props.enum}`, { search: value, ids: initial })
          .then((values) => {
            if (fetchId !== fetchRef.current) {
              // for fetch callback order
              return;
            }
            setOptions(values);
            setFetching(false);
          });
      } else {
        setOptions(
          props.values.filter((obj: { id: any; value: string }) =>
            obj.value.toLowerCase().includes((value ?? '')?.toLowerCase()),
          ),
        );
      }
    };

    return debounce(loadOptions, 300);
  }, [connection, props.enum, props.values]);

  useEffect(() => {
    if (fetchRef.current === 0) {
      debounceFetcher(undefined, props.value);
    }
  }, [props.value, debounceFetcher]);
  // const p = Utils.useOmitFields(props, 'enum', 'itemView');
  return (
    <Select
      showSearch
      value={props.value}
      onChange={props.onChange}
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      className={Utils.mergeClasses(props.className, 'autocomplete-input')}>
      {options.map((value) => (
        <Select.Option key={value.id} value={value.id}>
          {props.itemView ? props.itemView(value) : value.value}
        </Select.Option>
      ))}
    </Select>
  );
};
